import { env } from '@ria-client/env';

export const EMBEDS_URL =
  env.NEXT_PUBLIC_DEPLOYABLE_ENV === 'prod'
    ? 'https://embeds.nerdwallet.com'
    : 'https://embeds.nerdwallet.biz';
